import { render, staticRenderFns } from "./AccountInfoCard.vue?vue&type=template&id=b20dbbd6&scoped=true"
import script from "./AccountInfoCard.vue?vue&type=script&lang=js"
export * from "./AccountInfoCard.vue?vue&type=script&lang=js"
import style0 from "./AccountInfoCard.vue?vue&type=style&index=0&id=b20dbbd6&prod&scoped=true&lang=css"
import style1 from "./AccountInfoCard.vue?vue&type=style&index=1&id=b20dbbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20dbbd6",
  null
  
)

export default component.exports